import { Card, CardContent, Typography } from '@mui/material'
import { MenuBook, Bookmark, Star, Group } from '@mui/icons-material'
import { translations } from '../../translations';

interface UserStatsProps {
  booksRead: number
  booksWishlist: number
  avgRating: number
  followers: number
  isRtl: boolean
}

export function UserStats({ booksRead, booksWishlist, avgRating, followers, isRtl }: UserStatsProps) {
  const t = isRtl ? translations.ku : translations.en;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', direction: isRtl ? 'rtl' : 'ltr' }}>
      <Card dir={isRtl ? 'rtl' : 'ltr'}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, direction: isRtl ? 'rtl' : 'ltr' }}>
          <MenuBook sx={{ fontSize: 32, color: 'primary.main' }} />
          <Typography variant="body2" fontWeight="medium">
            {t.booksRead}
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            {booksRead}
          </Typography>
        </CardContent>
      </Card>
      <Card dir={isRtl ? 'rtl' : 'ltr'}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, direction: isRtl ? 'rtl' : 'ltr' }}>
          <Bookmark sx={{ fontSize: 32, color: 'primary.main' }} />
          <Typography variant="body2" fontWeight="medium">
            {t.booksWishlist}
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            {booksWishlist}
          </Typography>
        </CardContent>
      </Card>
      <Card dir={isRtl ? 'rtl' : 'ltr'}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, direction: isRtl ? 'rtl' : 'ltr' }}>
          <Star sx={{ fontSize: 32, color: 'primary.main' }} />
          <Typography variant="body2" fontWeight="medium">
            {t.avgRating}
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            {avgRating}
          </Typography>
        </CardContent>
      </Card>
      <Card dir={isRtl ? 'rtl' : 'ltr'}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, direction: isRtl ? 'rtl' : 'ltr' }}>
          <Group sx={{ fontSize: 32, color: 'primary.main' }} />
          <Typography variant="body2" fontWeight="medium">
            {t.followers}
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            {followers}
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}

